// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__ty3IZ","spinner":"Loading_spinner__YGLIk","crl":"Loading_crl__nObdF","small":"Loading_small__VFLsD"};